<template>
	<div class="tpl join-activity-wrap">
		<mt-header title="活动详情" fixed>
			<router-link :to="{name:'activity-detail',query:{id:aid}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="edit-list">
			<ul>
				<li>
					<span class="item-name">姓名</span>
					<span class="item-value"><input type="text" placeholder="填写姓名" v-model="name" @change="isEmpty"></span>
				</li>
				<li>
					<span class="item-name">性别</span>
					<span class="item-value"><input readonly type="text" placeholder="选择性别" :value="sex==1?'男':sex==2?'女':'未知'" @click.stop="chooseSex=!chooseSex;chooseAge=false;chooseAdd=false"></span>
				</li>
				<li>
					<span class="item-name">年龄</span>
					<span class="item-value"><input readonly type="text" placeholder="选择年龄" :value="age+'岁'" @click.stop="chooseAge=!chooseAge;chooseSex=false;chooseAdd=false"></span>
				</li>
				<li>
					<span class="item-name">所在城市</span>
					<span class="item-value"><input readonly type="text" :value="addressName.provName+'-'+addressName.cityName" @click.stop="chooseAdd=!chooseAdd;chooseAge=false;chooseSex=false;"></span>
				</li>
			</ul>
			<ul>
				<li>
					<span class="item-name">手机号</span>
					<span class="item-value"><input type="tel" placeholder="填写手机号" v-model="tel"></span>
				</li>
				<li>
					<span class="item-name">验证码</span>
					<span class="item-value check-code">
						<input type="text" placeholder="填写验证码" v-model="code">
						<button @click="codeFlag&&getCode()">
							<span v-if="codeFlag">获取验证码</span>
					<span v-else>{{seconds}}s</span>
					</button>
					</span>
				</li>
			</ul>
		</div>
		<div class="submit-btn">
			<button @click="submitInfo">提交</button>
		</div>
		<transition name="fade">
			<mt-picker :slots="sexOptions" @change="setSex" value-key="name" v-show="chooseSex"></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="ageOptions" @change="setAge" v-show="chooseAge"></mt-picker>
		</transition>
		<transition name="fade">
			<mt-picker :slots="addressList" @change="setAdd" value-key="name" v-show="chooseAdd" show></mt-picker>
		</transition>
	</div>
</template>

<script>
	export default {
		name: "join-activity",
		data() {
			return {
				uid: "",
				aid: "",
				name: "",
				sex: "",
				age: "",
				addressName: {
					provName: "",
					cityName: ""
				},
				provId: "",
				cityId: "",
				tel: "",
				code: "",
				chooseSex: false,
				chooseAge: false,
				chooseAdd: false,
				sexOptions: [{
					flex: 1,
					values: [{
							name: "男",
							id: 1
						},
						{
							name: "女",
							id: 2
						},
						{
							name: "未知",
							id: 0
						},
					],
					className: 'slot1',
					textAlign: 'center'
				}, ],
				firstSelect: true,
				addressList: [{
					flex: 1,
					values: [],
					className: 'slot1',
					textAlign: 'center'
				}, {
					divider: true,
					content: '-',
					className: 'slot2'
				}, {
					flex: 1,
					values: [],
					className: 'slot3',
					textAlign: 'center'
				}],
				seconds: 60,
				codeNum: "",
				codeFlag: true,
			}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "finds");
			this.$store.commit("changeTabBarShow", false);
			this.aid = this.$route.query.aid
			
			this.getBaseInfo();
			
			this.getAddressInfo(1, {
		      success: (res) => {
		        this.addressList[0].values = res
		      }
		    })
		},
		computed: {
			ageOptions() {
				let arr = [];
				for(let i = 18; i <= 70; i++) {
					arr.push(i + "岁")
				}
				let obj = [{
					flex: 1,
					values: arr,
					className: 'slot1',
					textAlign: 'center'
				}, ]
				return obj;
			},
		},
		methods: {
			getBaseInfo() {
				this.$axios({
					url:"appointment/EnrollActivityExhibition",
					method:"post",
					data:{
						uid: this.uid,
						aid: this.aid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code == 200) {
						this.sex = res.data.data.gender;
						this.age = res.data.data.age;
						this.addressName.provName = res.data.data.city[0];
						this.addressName.cityName = res.data.data.city[1];
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			getAddressInfo(id, options) {
				
				this.$axios({
					url:"Currency/getRegionInfoList",
					method:"post",
					data:{
						region_id: id,
					}
				}).then(res=>{
					if(res.data.code == 200) {
						let a = res.data.data.map(function(item) {
							let obj = {};
							obj.name = item.region_name;
							obj.id = item.region_id;
							return obj;
						})
						console.log(a);
						if(!!options && !!options.success) {
							options.success(a)
						}
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			setSex(index, value) {
				console.log(value[0].id)
				this.sex = value[0].id
			},
			setAge(index, value) {
				console.log(value[0]);
				this.age = Number(parseInt(value[0]))
			},
			setAdd(picker, value) {
				if(value[0]) {
					if(this.firstSelect === false) {
						this.provId = value[0].id;
						this.addressName.provName = value[0].name;
						this.getAddressInfo(value[0].id, {
							success: (res) => {
								picker.setSlotValues(1, res);
							}
						})
						if(value[1]) {
							this.cityId = value[1].id;
							this.addressName.cityName = value[1].name;
						}
					} else {
						this.firstSelect = !this.firstSelect;
					}
				}
			},
			isEmpty() {
				if(this.name == "" || null || undefined) {
					this.$toast({
						message: "没有更多内容了~",
						position: "bottom",
						duration: 3000
					})
				}
			},
			hideOption() {
				this.chooseSex = false;
				this.chooseAge = false;
				this.chooseAdd = false;
			},
			getCode() {
				if(!this.codeFlag) {
					this.$toast({
						message: "操作过于频繁！",
						position: "bottom",
						duration: 3000
					});
				} else if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					this.$toast({
						message: "请检查手机号是否正确",
						position: "bottom",
						duration: 3000
					});
				} else {					
					this.$axios({
						url:"Sms/mobilePhoneCheckCode",
						method:"post",
						data:{
							phone: this.tel,
							type: "E"
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code == 200) {
							this.$toast({
								message: "验证码发送成功！",
								position: "bottom",
								duration: 3000
							})
							this.codeNum = res.data.data.msgTxt;
							console.log(this.codeNum, this.code);
							this.codeFlag = false;
							this.culTime();
						} else {
							this.$toast({
								message: "验证码发送失败！请重试！",
								position: "bottom",
								duration: 3000
							})
						}
					}).catch(err=>{
						console.log(err)
					})
				}

			},
			culTime() {
				let _this = this;
				let t = setInterval(function() {
					if(_this.seconds > 0) {
						_this.seconds--
					} else {
						_this.seconds = 60;
						_this.codeFlag = true;
						clearInterval(t)
					}

				}, 1000)
			},
			submitInfo() {
				console.log(this.uid, this.aid, this.code, this.sex, this.addressName.cityName, this.name, this.age, this.tel);
				if(this.uid == "" || undefined || null) {
					this.$toast({
						message: "请登录后重试！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if(this.name == "" || undefined || null) {
					this.$toast({
						message: "请填写姓名！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if(this.sex == "" || undefined || null) {
					this.$toast({
						message: "请选择性别！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if(this.age == "" || undefined || null) {
					this.$toast({
						message: "请选择年龄！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if(this.addressName.cityNamee == "" || undefined || null) {
					this.$toast({
						message: "请选择地址！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					this.$toast({
						message: "请检查手机号是否正确！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else if((this.code == "" || undefined || null) || (this.code != this.codeNum)) {
					console.log(this.code,this.codeNum)
					this.$toast({
						message: "请检查验证码是否正确！",
						position: "bottom",
						duration: 3000
					});
					return false;
				} else {
					this.$axios({
						url:"Appointment/EnrollActivity",
						method:"post",
						data:{
							uid: this.uid,
							aid: this.aid,
							check_code: this.code,
							gender: this.sex,
							name: this.name,
							city: this.addressName.cityName,
							age: this.age,
							tel: this.tel,
						}
					}).then(res=>{
						console.log(res);
							if(res.data.code == 200) {
								this.$toast({
									message: "活动报名成功！",
									position: "bottom",
									duration: 3000
								});
								this.$router.push({
									name:"activity-list"
								})
							} else if(res.data.code == 300) {
								this.$toast({
									message: "不要重复报名活动！",
									position: "bottom",
									duration: 3000
								});
							} else {
								this.$toast({
									message: res.data.msg,
									position: "bottom",
									duration: 3000
								});
							}
					}).catch(err=>{
						console.log(err);
					})
				}
			}
		}
	}
</script>

<style scoped>
	.join-activity-wrap{
		padding-top: 2rem;
	}
	.edit-list ul {
		padding: 0 1.5rem;
		background: #fff;
		border-top: 0.5rem solid #f3f3f3;
	}
	
	.edit-list ul li {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem;
		border-bottom: 1px solid #f3f3f3;
	}
	
	.edit-list ul li .item-name {
		width: 4rem;
		font-size: 0.8rem;
		color: #282828;
	}
	
	.edit-list ul li .item-value {
		flex: 1;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.edit-list ul li .item-value input {
		width: 100%;
		height: 2rem;
		border: 0;
		outline: 0;
		background: none;
		font-size: 0.8rem;
		color: #282828;
	}
	
	.edit-list .item-value.check-code input {
		width: 60%;
	}
	
	.edit-list .item-value.check-code button {
		background: none;
		font-size: 0.8rem;
		color: #7b7b7b;
		border: 1px solid #7b7b7b;
		padding: 0.3rem 0.5rem;
		border-radius: 3px;
		outline: 0;
	}
	
	.submit-btn {
		padding: 4rem 2rem 2rem;
	}
	
	.submit-btn button {
		width: 100%;
		height: 2.5rem;
		background: #e1e1e1;
		color: #7b7b7b;
		border: 0;
		outline: 0;
		border-radius: 4px;
	}
	
	.picker-items .picker-item {
		font-size: 0.8rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/JoinActivity.vue